<template>
  <v-select
    v-model="selected"
    :items="items"
    :label="filterDisplay"
    multiple
    @blur="blured"
  >
    <template v-slot:prepend-item>
      <v-list-item ripple @click="toggle">
        <v-list-item-action>
          <v-icon :color="selected.length > 0 ? 'primary' : ''">{{
            icon
          }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("interface.selectAll") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="!selectedAll" color="primary" small>
        <span>{{ item.shortText }}</span>
      </v-chip>
      <span v-if="selectedAll && index === 1" class="caption">{{
        allSelectedText
      }}</span>
    </template>
  </v-select>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mdiCloseBox, mdiMinusBox, mdiCheckboxBlankOutline } from "@mdi/js";
export default {
  props: {
    filter: {
      type: String,
      required: true
    },
    category: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(["filterSelected", "filterOptions"]),
    options() {
      return this.filterOptions(this.filter);
    },
    items() {
      return this.options.map(option => {
        const text = this.$t(
          `filters.${this.category}.${this.filter}.options.${option}`
        );
        const parenthesisIndex = text.indexOf("(");
        const shortText =
          parenthesisIndex === -1 ? text : text.slice(0, parenthesisIndex - 1);
        return {
          text,
          shortText,
          value: option
        };
      });
    },
    selected: {
      get() {
        return this.filterSelected(this.filter);
      },
      set(value) {
        this.updateFilter({ filter: this.filter, value });
      }
    },
    filterDisplay() {
      return this.$t(`filters.${this.category}.${this.filter}.label`);
    },
    selectedAll() {
      return this.selected.length === this.options.length;
    },
    selectedSome() {
      return this.selected.length > 0 && !this.selectedAll;
    },
    icon() {
      if (this.selectedAll) return mdiCloseBox;
      if (this.selectedSome) return mdiMinusBox;
      return mdiCheckboxBlankOutline;
    },
    allSelectedText() {
      return this.$t("interface.allSelected", { count: this.options.length });
    }
  },
  methods: {
    ...mapActions(["updateFilter"]),
    toggle() {
      this.$nextTick(() => {
        if (this.selectedAll) {
          this.selected = [];
        } else {
          this.selected = this.options.slice();
        }
      });
    },
    blured() {
      if (this.selected.length === 0) {
        this.selected = this.options.slice();
      }
    }
  }
};
</script>